import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_DRIVERS_ASSISTANT_TABLE = 'FETCH_DRIVERS_ASSISTANT_TABLE'
export const RECEIVE_DRIVERS_ASSISTANT_TABLE = 'RECEIVE_DRIVERS_ASSISTANT_TABLE'
export const FAILED_DRIVERS_ASSISTANT_TABLE = 'FAILED_DRIVERS_ASSISTANT_TABLE'

export function fetchDriversAssistantTable(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_DRIVERS_ASSISTANT_TABLE});
        axios({
            method: 'post',
            url: API_LINKS.DRIVER_ASSISTANT_LIST_URL,
            headers: {
                Authorization: auth
            },
            // data: {
            //     dev: 'T02',
            //     // date: 
            //     // For Parameters
            // }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_DRIVERS_ASSISTANT_TABLE,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DRIVERS_ASSISTANT_TABLE
                    })
                    return toast.error('Unathorized access!');
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DRIVERS_ASSISTANT_TABLE
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DRIVERS_ASSISTANT_TABLE
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DRIVERS_ASSISTANT_TABLE
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DRIVERS_ASSISTANT_TABLE
                })
                return toast.error("Something went wrong!... Please try again later.");
            } else {
                dispatch({
                    type: FAILED_DRIVERS_ASSISTANT_TABLE
                })
                return toast.error("Something went wrong!... Please try again later.");
            }

        })
    }
}